module.exports = __webpack_public_path__ + "img/lifepak-15.86057567.png";